import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const UserMedcardGrpcContractProvider: Provider = {
  provide: MainApi.UserMedcardGrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.UserMedcardGrpcContractClient, 'mainApi'),
};
